export default {
  buttons: { done: 'Valmis' },
  title: 'Sijainti',
};
